import { render, staticRenderFns } from "./PacientePorId.vue?vue&type=template&id=96cfdfa8&scoped=true"
import script from "./PacientePorId.vue?vue&type=script&lang=js"
export * from "./PacientePorId.vue?vue&type=script&lang=js"
import style0 from "./PacientePorId.vue?vue&type=style&index=0&id=96cfdfa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96cfdfa8",
  null
  
)

export default component.exports